import { addDays, subDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { weekday } from '../../../helpers/constants';
import { createWorkItemDate } from '../domain/AvailabilityDate';
import { WorkCalendarRecord } from '../types';

export const getEmptyWeekdaysToPrepend = (date: Date, timeZone: string) => {
    const dateTz = toZonedTime(date, timeZone);
    const day = dateTz.getDay();
    const skipPrepend = day === weekday.monday;

    if (skipPrepend) {
        return [];
    }

    const prependAmount = day === weekday.sunday ? 6 : day - 1;

    const datesToPrepend = [ ...new Array(prependAmount) ].map((_, i) => createWorkItemDate(subDays(date, prependAmount - i), null));

    return datesToPrepend;
};

export const getEmptyWeekdaysToAppend = (date: Date, timeZone: string) => {
    const dateTz = toZonedTime(date, timeZone);
    const day = dateTz.getDay();
    const skipAppend = day === weekday.sunday;

    if (skipAppend) {
        return [];
    }

    const appendAmount = 7 - day;

    const datesToAppend = [ ...new Array(appendAmount) ].map((_, i) => createWorkItemDate(addDays(date, appendAmount - i), null));

    return datesToAppend.reverse();
};

export function fillWeeks(availabilityDates: WorkCalendarRecord[], timeZone: string) {
    if (availabilityDates.length === 0) {
        return [];
    }

    const start = availabilityDates[0];
    const end = availabilityDates[availabilityDates.length - 1];

    const datesToPrepend = getEmptyWeekdaysToPrepend(new Date(start.date), timeZone);
    const datesToAppend = getEmptyWeekdaysToAppend(new Date(end.date), timeZone);

    const filledWeeks = [ ...datesToPrepend, ...availabilityDates, ...datesToAppend ];

    return filledWeeks;
}

export default fillWeeks;
